import { HelpCircle } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconHelp(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <HelpCircle />
    </IconWrapper>
  );
}
